import React from 'react';
import { AiOutlineMail, AiOutlinePhone } from 'react-icons/ai';
import {
    FaClock,
    FaDribbble,
    FaFacebookF,
    FaLinkedinIn,
    FaMap,
    FaPlus,
    FaTwitter,
    FaYoutube
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import logo from '../../assets/img/cyto-logo-250x75.jpg';

function OffsetMenu({ className, handleOffset }) {
    return (
        <div className={className}>
            <span id="offset-menu-close-btn">
                <FaPlus onClick={handleOffset} />
            </span>
            <div className="offset-menu-wrapper text-white">
                <div className="offset-menu-header">
                    <div className="offset-menu-logo">
                        <Link to="/">
                            <img src={logo} alt="logo" />
                        </Link>
                    </div>
                </div>
                <div className="offset-menu-section">
                    <h3>About Us</h3>
                    <p>
                    Cytocare Technologies is a service provider for clinical researcher, Medical Oncologist, Haematologist and regulatory experts involved in cell processing and stem cell therapy. We endeavour to promote our diversity, so fostering the original thoughts and creativity.
                    </p>
                    <Link to="/contact" className="theme-btn mt-30">
                        Consultation
                    </Link>
                </div>
                <div className="offset-menu-section">
                    <h3>Contact Info</h3>
                    <ul>
                        <li>
                            <span>
                                <FaMap />
                            </span>
                            10-5-G1, PVN Colony, Mirjalguda, Malkajgiri, Hyderabad - 500047, Telangana, India
                        </li>
                        <li>
                            <span>
                                <AiOutlinePhone />
                            </span>
                            (+91) 984-918-8772
                        </li>
                        <li>
                            <span>
                                <AiOutlineMail />
                            </span>
                            contact@cytocaretech.com
                        </li>
                    </ul>
                </div>
                <div className="offset-menu-footer">
                    <div className="offset-menu-social-icon">
                        <a href="https://www.facebook.com/CytocaretechnologiesPvtLtd">
                            <FaFacebookF />
                        </a>
                        <a href="/">
                            <FaTwitter />
                        </a>
                        <a href="/">
                            <FaLinkedinIn />
                        </a>
                        <a href="/">
                            <FaDribbble />
                        </a>
                        <a href="/">
                            <FaYoutube />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OffsetMenu;
